import { View, Text, RadioGroup, Label, YStack } from 'tamagui'
import { QuestionWrapper } from './QuestionWrapper'

interface ITrueFalseQuestionProps {
  statement: string
  selectedValue?: string
  onSelect: (value: string) => void
}

export function TrueFalseQuestion({
  statement,
  selectedValue,
  onSelect,
}: ITrueFalseQuestionProps) {
  return (
    <View>
      {statement && (
        <View
          backgroundColor="$neutral-100"
          borderRadius="$border-radius-sm"
          p="$spacing-inset-xs"
          mb="$spacing-inset-xs"
        >
          <Text color="$neutral-700" fontSize="$font-size-sm">
            {statement}
          </Text>
        </View>
      )}

      <RadioGroup
        name="true-false"
        onValueChange={onSelect}
        value={selectedValue}
      >
        <YStack gap="$spacing-inset-nano">
          {/* Opção Verdadeiro */}
          <QuestionWrapper isSelected={selectedValue === 'true'}>
            <View flexDirection="row" alignItems="center">
              <RadioGroup.Item
                value="true"
                id="true"
                borderColor="$neutral-200"
                backgroundColor={
                  selectedValue === 'true' ? '$primary-300' : 'transparent'
                }
                size={'$spacing-lg'}
              >
                <RadioGroup.Indicator
                  borderWidth={1}
                  w={8}
                  h={8}
                  borderColor={
                    selectedValue === 'true' ? '$primary-300' : '$neutral-300'
                  }
                  backgroundColor={
                    selectedValue === 'true' ? '$neutral-100' : 'transparent'
                  }
                />
              </RadioGroup.Item>
              <Label
                color="$neutral-800"
                fontFamily="$mulishRegular"
                size={'$font-size-xxs'}
                htmlFor="true"
                p="$spacing-inset-xs"
                flex={1}
              >
                Verdadeiro
              </Label>
            </View>
          </QuestionWrapper>

          {/* Opção Falso */}
          <QuestionWrapper isSelected={selectedValue === 'false'}>
            <View flexDirection="row" alignItems="center">
              <RadioGroup.Item
                value="false"
                id="false"
                borderColor="$neutral-200"
                backgroundColor={
                  selectedValue === 'false' ? '$primary-300' : 'transparent'
                }
                size={'$spacing-lg'}
              >
                <RadioGroup.Indicator
                  borderWidth={1}
                  w={8}
                  h={8}
                  borderColor={
                    selectedValue === 'false' ? '$primary-300' : '$neutral-300'
                  }
                  backgroundColor={
                    selectedValue === 'false' ? '$neutral-100' : 'transparent'
                  }
                />
              </RadioGroup.Item>
              <Label
                color="$neutral-800"
                fontFamily="$mulishRegular"
                size={'$font-size-xxs'}
                htmlFor="false"
                p="$spacing-inset-xs"
                flex={1}
              >
                Falso
              </Label>
            </View>
          </QuestionWrapper>
        </YStack>
      </RadioGroup>
    </View>
  )
}
